import { config } from "../../config";
import { Button as AntdButton, Typography, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export default function HButton(props) {
  const {
    children,
    type = "primary",
    size = "m",
    buttonClassName = "",
    prefixIcon,
    suffixIcon,
    icon,
    onClick = () => {},
    variant,
    loading,
    disabled,
    "data-cy": datacy,
    truncateText = false,
    htmlType = "button",
    loadingColor = "",
    tabIndex,
  } = props;
  const buttonConfiguration = config.button || "";
  const buttonConfigurationByType = config.button.type[type] || "";
  const buttonConfigurationBySize = config.button.size[size] || "";
  const buttonConfigurationByVariant = config.button.variant[variant] || "";
  const { Text } = Typography;
  const antIcon = <LoadingOutlined className={`loading-button ${loadingColor ? loadingColor : ""}`} spin />;
  const customIcon = <Spin indicator={antIcon} />;
  return (
    <AntdButton
      icon={icon}
      onClick={onClick}
      disabled={disabled}
      loading={false}
      iconPosition="center"
      className={`${buttonConfiguration?.customClasses || ""} ${buttonConfigurationBySize?.customClasses || ""} ${
        buttonConfigurationByType?.customClasses || ""
      } ${buttonConfigurationByVariant?.customClasses || ""} ${buttonClassName}`}
      data-cy={datacy}
      htmlType={htmlType}
      tabIndex={tabIndex}
    >
      <div className={`d-flex justify-content-between mx-auto ${children ? "gap-1" : ""} align-items-center ${truncateText ? "w-100" : ""}`}>
        {prefixIcon && <>{prefixIcon}</>}
        {loading ? (
          buttonConfigurationByVariant?.customClasses === "hs-button-v-cancel" ? (
            <div className="d-flex justify-content-center antd-loading-icon hs-min-h-68-vh hs-fs-14">
              <LoadingOutlined spin className="" />
            </div>
          ) : (
            <div>{customIcon}</div>
          )
        ) : (
          <Text ellipsis className={`px-auto m-auto ${buttonConfigurationByType?.textCustomClasses || ""}`}>
            {children}
          </Text>
        )}
        {suffixIcon && <>{suffixIcon}</>}
      </div>
    </AntdButton>
  );
}
